<script>
import {vMaska} from "maska";

export default {
  name: "ExpenseObject",
  directives: {maska: vMaska},
  data: () => {
    return {
      objs: '',
      search: '',
      obj: {
        title: '',
        code: '',
        description: '',
      },
      editingObj: ''
    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredObj() {
      if (!this.search) {
        return this.objs;
      }
      return this.objs.filter(obj => obj.title.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  methods: {
    async getObjData() {
      try {
        let res = await this.$api.get("/auth/expense-objects");
        if (res.status.toString() === "200") {
          this.objs = res.data
        }
      } catch (error) {
        console.log("can't get obj data")
      }
    },
    async regObj() {
      if (this.obj.code.length < 3 || this.obj.title.length < 2) {
        this.$swal.fire({
          icon: 'error',
          title: 'Verifique los datos nuevamente',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {
        let data = {
          title: this.obj.title, code: this.obj.code, description: this.obj.description,
        }
        let result = await this.$api.post("/auth/expense-objects", data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getObjData()
          this.obj = {
            title: '',
            expenseObj: '',
            description: '',
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los  cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async regObjChanges() {
      if (this.editingObj.code.length < 3 || this.editingObj.title.length < 2) {
        this.$swal.fire({
          icon: 'error',
          title: 'Verifique los datos nuevamente',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {
        let data = {
          title: this.editingObj.title, description: this.editingObj.description,
        }
        let result = await this.$api.put(`/auth/expense-objects/${this.editingObj.id}`, data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "200") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getObjData()
          this.editingObj = ''
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }

    },
    editObj(obj) {
      this.editingObj = obj;
      this.getObjData()
    },
    cancelEdit() {
      this.editingObj = ''
    },
    inputLimiterSearch() {
      this.search = this.search.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterTitle() {
      this.obj.title = this.obj.title.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterCode() {
      this.obj.code = this.obj.code.replace(/[^0-9 ]/gi, '').trimStart();
    },
    inputLimiterDescription() {
      this.obj.description = this.obj.description.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterTitleEdit() {
      this.editingObj.title = this.editingObj.title.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterDescriptionEdit() {
      this.editingObj.description = this.editingObj.description.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterCodeEdit() {
      this.editingObj.code = this.editingObj.code.replace(/[^0-9 ]/gi, '').trimStart();
    },

  },

  created() {
    this.getObjData()
  }
}

</script>

<template>
  <h1>Objetos del gasto</h1>

  <div class="grid-container-left">
    <!--first column -->
    <div>

      <form class="Form">
        <input type="text" v-model="search" v-on:input="inputLimiterSearch" maxlength="250"
               placeholder="Buscar objeto del gasto ...">
      </form>

      <div class="container mt-4 table-container" v-if="filteredObj.length > 0">

        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Título</th>
            <th>Código</th>
            <th v-if="sidebarData.includes('ad-prov-expense-obj-edit')">Opciones</th>
          </tr>

          </thead>
          <tbody>

          <tr v-for="(obj, index) in filteredObj" :key="obj.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ obj.title }}</td>
            <td>{{ obj.code }}</td>
            <td class="td_align_center" v-if="sidebarData.includes('ad-prov-expense-obj-edit')">
              <button class="tableBtn" @click="editObj(obj)" role="link">Editar</button>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <div v-else>
        <p class="bordered-p">No se encontraron objetos del gasto.</p>
      </div>

    </div>

    <!-- second column -->
    <div v-if="sidebarData.includes('ad-prov-expense-obj-reg') || editingObj">
      <div v-if="!editingObj">
        <h2>Registrar objeto del gasto</h2>
        <form class="Form">
          <label>Titulo</label>
          <input type="text" v-model="obj.title" v-on:input="inputLimiterTitle" maxlength="250"
                 placeholder="Titulo del objeto del gasto">
          <label>Codigo</label>
          <input type="text" v-model="obj.code" v-on:input="inputLimiterCode" maxlength="10"
                 placeholder="Codigo del objeto del gasto">
          <label>Descripción</label>
          <textarea v-model="obj.description" v-on:input="inputLimiterDescription" maxlength="1000"
                    placeholder="Descripcion"></textarea>
          <button type="submit" @click.prevent="regObj">Registrar</button>
        </form>
      </div>

      <div v-if="editingObj">
        <h2>Editar objeto del gasto</h2>
        <form class="Form">
          <label>Titulo</label>
          <input type="text" v-model="editingObj.title" v-on:input="inputLimiterTitleEdit" maxlength="250"
                 placeholder="Título del objeto del gasto ">
          <label>Codigo</label>
          <input disabled type="text" v-model="editingObj.code" v-on:input="inputLimiterCodeEdit" maxlength="10"
                 placeholder="Código del objeto del gasto ">
          <label>Descripción</label>
          <textarea v-model="editingObj.description" v-on:input="inputLimiterDescriptionEdit" maxlength="1000">
        </textarea>
          <button type="submit" @click.prevent="regObjChanges">Guardar Cambios</button>
          <button type="submit" @click.prevent="cancelEdit">Cancelar</button>
        </form>
      </div>

      <div>
      </div>
    </div>

  </div>

</template>

<style>

</style>